
import { useMovieDialog } from "./useMovieDialog";

/**
 * Hook for opening movie details in responsive dialog mode
 * Pure TMDB ID system - expects numeric TMDB IDs and converts for dialog system
 */
export const useOpenMovieDetails = (context: "library" | "search" = "library") => {
  const { setExpandedMovieId } = useMovieDialog();

  const openMovieDetails = (tmdbId: number) => {
    console.log(`Opening movie details for TMDB ID: ${tmdbId} in dialog mode from ${context}`);
    
    // Open in responsive dialog mode using string format for dialog system
    setExpandedMovieId(`tmdb_${tmdbId}`);
  };

  return openMovieDetails; // Return the function directly for compatibility
};
